import {
  bool,
  number,
  string,
  shape,
} from 'prop-types';

import { quality } from 'fera-prop-types/qualities';

export const propTypes = {
  category: string.isRequired,
  nature: string.isRequired,
  qualityName: string.isRequired,
  qualityId: number.isRequired,
  levelBefore: number.isRequired,
  xpBefore: number.isRequired,
  levelAfter: number.isRequired,
  xpAfter: number.isRequired,
  usesProgressBars: bool.isRequired,
  leftScore: number.isRequired,
  rightScore: number.isRequired,
  startPercentage: number.isRequired,
  endPercentage: number.isRequired,
  changeType: string.isRequired,
  isSidebar: bool.isRequired,
  type: string.isRequired,
  message: string.isRequired,
  image: string.isRequired,
  tooltip: string.isRequired,
  possession: quality.isRequired,
};

export default shape(propTypes);